import { Outlet, useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import PageTransition from "./PageTransition";
import OfflineBanner from "./OfflineBanner";
import { useStandaloneMode } from "@/hooks/useStandaloneMode";
import { useGlobalChromeHidden } from "./chromeVisibility";
import { cn } from "@/lib/utils";
import { useTranslation } from "react-i18next";

const Layout = () => {
  const location = useLocation();
  const isStandalone = useStandaloneMode();
  const chromeHidden = useGlobalChromeHidden();
  const { t } = useTranslation();


  return (
    <div className={cn(
      "flex min-h-screen flex-col overflow-x-hidden",
      isStandalone && "standalone-mode"
    )}>
      <OfflineBanner />
      
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[100] focus:px-4 focus:py-2 focus:bg-[var(--color-navy)] focus:text-white focus:text-sm focus:font-semibold focus:rounded"
      >
        {t('chrome.skipToContent')}
      </a>
      {!chromeHidden && <Navbar />}
      <main 
        id="main-content" 
        tabIndex={-1} 
        className={cn(
          "flex-1 overflow-x-clip outline-none",
          !chromeHidden && "pt-[72px]",
          !chromeHidden && isStandalone && "pt-[calc(72px+env(safe-area-inset-top))]"
        )} 
        role="main"
      >
        <PageTransition key={location.pathname}>
          <Outlet />
        </PageTransition>
      </main>
      {!chromeHidden && <Footer />}

    </div>
  );
};

export default Layout;
